import * as React from "react";

import {styled} from "@mui/joy/styles";
import GlobalStyles from "@mui/joy/GlobalStyles";

import AspectRatio from "@mui/joy/AspectRatio";
import Avatar from "@mui/joy/Avatar";
import Box from "@mui/joy/Box";
import Divider from "@mui/joy/Divider";
import IconButton from "@mui/joy/IconButton";
import List from "@mui/joy/List";
import ListItem from "@mui/joy/ListItem";
import ListItemButton from "@mui/joy/ListItemButton";
import ListItemContent from "@mui/joy/ListItemContent";
import ListItemDecorator from "@mui/joy/ListItemDecorator";
import ListDivider from "@mui/joy/ListDivider";
import Typography from "@mui/joy/Typography";
import Sheet from "@mui/joy/Sheet";

import FeatherIcon from "feather-icons-react";

import {menuIterator} from "../../../fwptools";
import fairwindsLogo from "../../../images/fairwinds-sail-square.png";
import {closeSidebar} from "./utilities";

const Dropdown = styled("i")(({theme}) => ({
    color: theme.vars.palette.text.tertiary
}));

export default function Sidebar({path, navigate, user}) {

    return (
        <Sheet className="Sidebar" sx={sxSheet}>
            <GlobalStyles
                styles={(theme) => ({
                    ":root": {
                        "--Sidebar-width": "224px", [theme.breakpoints.up("lg")]: {
                            "--Sidebar-width": "256px"
                        }
                    }
                })}
            />
            <Box className="Sidebar-overlay" onClick={() => closeSidebar()} sx={sxSidebarOverlay}/>

            <Box sx={{display: "flex", gap: 1, alignItems: "center"}}>
                <AspectRatio ratio="1" variant="plain" sx={[{width: 36, borderRadius: "sm"}]}>
                    <img src={fairwindsLogo}/>
                </AspectRatio>
                <Typography fontSize="lg" fontWeight="xl">fwptools</Typography>
            </Box>

            <Box sx={{minHeight: 0, overflow: "hidden auto", flexGrow: 1, display: "flex", flexDirection: "column"}}>
                <List size="sm" sx={sxMenuList}>
                    {addMenus(navigate, path, user)}
                </List>

                {/*<List sx={sxAdminList}>*/}
                {/*    <ListItem>*/}
                {/*        <ListItemButton>*/}
                {/*            <ListItemDecorator>*/}
                {/*                <i data-feather="settings"/>*/}
                {/*            </ListItemDecorator>*/}
                {/*            <ListItemContent>Settings</ListItemContent>*/}
                {/*        </ListItemButton>*/}
                {/*    </ListItem>*/}
                {/*</List>*/}
            </Box>

            <Divider/>

            <Box sx={{display: "flex", gap: 1, alignItems: "center"}}>
                <Avatar src={user.getAvatar()}/>
                <Box sx={{minWidth: 0, flex: 1}}>
                    <Typography fontSize="sm" fontWeight="lg">{user.getFullName()}</Typography>
                    <Typography level="body3">{user.getEmailAddress()}</Typography>
                </Box>
                <IconButton color="neutral" onClick={() => navigate("/logout")} variant="plain">
                    <FeatherIcon icon="log-out"/>
                </IconButton>
            </Box>
        </Sheet>);
}

const addMenuItem = (navigate, object, path, user) => {
    if (!(object.isLink()) && user.hasPermission(object.getRbac())) {
        return null;
    }

    if (object.isDivider()) {
        return createMenuDivider(object);
    }

    if (object.isSubMenu()) {
        return createSubMenu(navigate, object, path, user);
    }

    return createMenuItem(navigate, object, path);
};

const addMenus = (navigate, path, user, children = undefined) => {
    return menuIterator(object => {
        return addMenuItem(navigate, object, path, user);
    }, children);
};

const createMenuItem = (navigate, object, path) => {
    const link = object.getLink();
    return (<ListItem key={link}>
        <ListItemButton onClick={() => navigate(link)} selected={link === path}>
            <ListItemDecorator>
                <FeatherIcon icon={object.getIcon()}/>
            </ListItemDecorator>
            <ListItemContent>{object.getMenu()}</ListItemContent>
        </ListItemButton>
    </ListItem>);
};

const createMenuDivider = (object) => {
    return (<ListDivider key={object.getLink()}/>);
};

const createSubMenu = (navigate, object, path, user) => {
    return (<ListItem key={object.getLink()} nested>
        <ListItemButton>
            <ListItemDecorator>
                <FeatherIcon icon={object.getIcon()}/>
            </ListItemDecorator>
            <ListItemContent>{object.getMenu()}</ListItemContent>
            <Dropdown data-feather="chevron-down"/>
        </ListItemButton>
        <List>
            {addMenus(navigate, path, user, object.getChildren())}
        </List>
    </ListItem>);
};

// css

const sxAdminList = {
    mt: "auto", flexGrow: 0, "--ListItem-radius": "8px", "--List-gap": "8px"
};

const sxMenuList = {
    "--ListItem-radius": "8px", "--List-gap": "4px", "--List-nestedInsetStart": "40px"
};

const sxSidebarOverlay = {
    position: "fixed",
    zIndex: 9998,
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    bgcolor: "background.body",
    opacity: "calc(var(--SideNavigation-slideIn, 0) - 0.2)",
    transition: "opacity 0.4s",
    transform: {
        xs: "translateX(calc(100% * (var(--SideNavigation-slideIn, 0) - 1) + var(--SideNavigation-slideIn, 0) * var(--Sidebar-width, 0px)))",
        lg: "translateX(-100%)"
    }
};

const sxSheet = {
    position: {
        xs: "fixed", md: "sticky"
    },
    transform: {
        xs: "translateX(calc(100% * (var(--SideNavigation-slideIn, 0) - 1)))", md: "none"
    },
    transition: "transform 0.4s, width 0.4s",
    zIndex: 10000,
    height: "100dvh",
    width: "var(--Sidebar-width)",
    top: 0,
    p: 1.5,
    py: 3,
    flexShrink: 0,
    display: "flex",
    flexDirection: "column",
    gap: 2,
    borderRight: "1px solid",
    borderColor: "divider"
};